import React, { useState } from "react";
import { Card } from "../../../common";
import { ReactComponent as ArrowIcon } from "../../../../assets/icons/accordion.svg";
import { ResetPassword } from "./ResetPassword";

export const ProfileSettings = () => {
  const [accordionState, setAccordionState] = useState({
    passwordResetOpen: false,
    emailPreferencesOpen: false,
  });

  const toggleAccordion = (accordionName) => {
    setAccordionState((prevState) => ({
      ...prevState,
      [accordionName]: !prevState[accordionName],
    }));
  };

  return (
    <Card classes="w-full md:col-start-9 md:col-end-13 bg-white rounded-xl p-6">
      <h4 className="text-secondarytwo text-f24 font-bold text-left">
        Profile Settings
      </h4>
      <div className="mt-8">
        <div className="border rounded mb-6 border-slate">
          <div
            className="flex items-center justify-between p-3 cursor-pointer text-f16 text-primary"
            onClick={() => toggleAccordion("passwordResetOpen")}
          >
            <span>Password Reset</span>
            <div
              className={`transition-transform ${
                accordionState.passwordResetOpen ? "transform rotate-180" : ""
              }`}
            >
              <ArrowIcon />
            </div>
          </div>
          {accordionState.passwordResetOpen && (
            <div className="p-3 bg-white text-left">
              <ResetPassword />
            </div>
          )}
        </div>

        <div className="border rounded mb-6 border-slate">
          <div
            className="flex items-center justify-between p-3 cursor-pointer text-f16 text-primary"
            onClick={() => toggleAccordion("emailPreferencesOpen")}
          >
            <span>Email Preferences</span>
            <div
              className={`transition-transform ${
                accordionState.emailPreferencesOpen
                  ? "transform rotate-180"
                  : ""
              }`}
            >
              <ArrowIcon />
            </div>
          </div>
          {accordionState.emailPreferencesOpen && (
            <div className="p-3 bg-white text-left">
            </div>
          )}
        </div>
      </div>
    </Card>
  );
};
